/**
 * Suggerimento automatico nel cassetto del carrello.
 *
 * Dopo ogni aggiunta al carrello, se il prodotto non ha un abbinamento scelto
 * a mano (metafield "upsell"/"upsell_list"), chiede a Shopify i prodotti
 * comprati insieme più spesso al prodotto appena aggiunto, e se non ne trova
 * abbastanza completa con i best-seller della collezione di riserva
 * (impostata in sections/cart-auto-upsell.liquid).
 *
 * Non tocca nulla se è già presente un abbinamento manuale.
 */
(function () {
  var isLoading = false;

  function getUpsellHolder() {
    return document.querySelector('[data-pair-products-holder]');
  }

  function hasManualUpsell(holder) {
    return !!(holder && holder.querySelector('[data-upsell-holder]'));
  }

  function loadAutoUpsell() {
    if (isLoading) return;

    var holder = getUpsellHolder();
    if (!holder || hasManualUpsell(holder)) return;
    if (!window.theme || !window.theme.routes || !window.theme.routes.product_recommendations_url) return;

    isLoading = true;

    fetch('/cart.js')
      .then(function (response) { return response.json(); })
      .then(function (cart) {
        if (!cart.items || !cart.items.length) {
          isLoading = false;
          return;
        }

        var cartHandles = cart.items.map(function (item) { return item.handle; });
        var lastItem = cart.items[cart.items.length - 1];

        var url = window.theme.routes.product_recommendations_url
          + '?section_id=cart-auto-upsell'
          + '&product_id=' + encodeURIComponent(lastItem.product_id)
          + '&limit=4&intent=complementary';

        return fetch(url)
          .then(function (response) { return response.text(); })
          .then(function (html) {
            var wrapper = document.createElement('div');
            wrapper.innerHTML = html;

            var cards = Array.prototype.slice.call(wrapper.querySelectorAll('[data-upsell-holder]'));
            if (!cards.length) {
              isLoading = false;
              return;
            }

            var kept = [];
            var seenHandles = {};

            cards.forEach(function (card) {
              if (kept.length >= 2) return;

              var actionEl = card.querySelector('[data-handle]');
              var handle = actionEl ? actionEl.getAttribute('data-handle') : null;

              if (!handle || seenHandles[handle] || cartHandles.indexOf(handle) !== -1) return;

              seenHandles[handle] = true;
              kept.push(card);
            });

            if (!kept.length) {
              isLoading = false;
              return;
            }

            // Ricontrolla all'ultimo momento: nel frattempo il cassetto potrebbe
            // essere stato rigenerato da Shopify (es. altra modifica al carrello).
            holder = getUpsellHolder();
            if (!holder || hasManualUpsell(holder)) {
              isLoading = false;
              return;
            }

            var container = document.createElement('div');
            container.setAttribute('data-pair-products', '');
            kept.forEach(function (card) { container.appendChild(card); });

            holder.innerHTML = '';
            holder.appendChild(container);
            isLoading = false;
          });
      })
      .catch(function () {
        isLoading = false;
      });
  }

  [
    'theme:cart:added',
    'theme:cart:refresh',
    'theme:cart:update',
    'theme:cart:loaded'
  ].forEach(function (eventName) {
    document.addEventListener(eventName, loadAutoUpsell);
  });

  // Copre anche il caso in cui il cliente apre direttamente la pagina /cart
  // (nessun evento di "aggiunta al carrello" scatta in quel momento).
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', loadAutoUpsell);
  } else {
    loadAutoUpsell();
  }
})();
